var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 16,
    height: 12,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8 L12 4 L20 8",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 3,
    height: 2,
    fill: "currentColor",
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 1,
    fill: "currentColor",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/materials.7957ea6ac41a7afbb91bb9c8b7be0b3c.svg";
export { ForwardRef as ReactComponent };